import { NavLink, Link, useLocation } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import React, { useState, useEffect, useRef } from "react";

import "./Navbar.css";

import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";

import { useCart } from "../context/CartContext";

function Navbar() {
  const [click, setClick] = useState(false);
  const [navBackground, setNavBackground] = useState(false);

  const navRef = useRef();

  const { cartCount } = useCart();

  const location = useLocation();

  // Keep navbar/cart dark on all print-related pages
  const isPrintPage =
    location.pathname === "/cart" ||
    location.pathname === "/prints/information" ||
    location.pathname.startsWith("/prints/");

  const shouldUseWhite = navBackground && !isPrintPage;

  navRef.current = navBackground;

  const handleClick = () => {
    setClick(!click);
  };

  const closeMobileMenu = () => {
    setClick(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 25;

      if (navRef.current !== show) {
        setNavBackground(show);
      }
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setClick(false);
  }, [location.pathname]);

  return (
    <motion.nav className="navbar">
      <div
        className="navbar-container"
        style={{
          color: shouldUseWhite ? "#ffffff" : "#121212",
          transition: "color .1s ease-in-out",
        }}
      >
        <NavLink to="/" className="brand" onClick={closeMobileMenu}>
          <div className="brand">
            OCTAVIO
            <span className="last">GARCIA</span>
          </div>
        </NavLink>

        <div className="menu-icon" onClick={handleClick}>
          {click ? <RiCloseFill /> : <RiMenu3Fill />}
        </div>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <NavLink
              to="/"
              className="nav-links"
              onClick={closeMobileMenu}
              exact
              activeClassName="is-active"
            >
              photographs
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/info"
              className="nav-links"
              onClick={closeMobileMenu}
              exact
              activeClassName="is-active"
            >
              info
            </NavLink>
          </li>

          {/* 
<li className="nav-item">

            <NavLink
              to="/prints"
              className="nav-links"
              onClick={closeMobileMenu}
              exact
              activeClassName="is-active"
            >
              prints
            </NavLink>
          </li>
*/}
        </ul>
      </div>

      <AnimatePresence>
        {cartCount > 0 && (
          <motion.div
            className="navbar-cart"
            id="navbar-cart-target"
            initial={{
              opacity: 0,
              x: 20,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            exit={{
              opacity: 0,
              x: 20,
            }}
            transition={{
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1],
            }}
            style={{
              color: shouldUseWhite ? "#ffffff" : "#121212",
              transition: "color 1s ease-in-out",
            }}
          >
            <Link
              to="/cart"
              className="navbar-cart-link"
              onClick={closeMobileMenu}
            >
              <span>cart</span>

              <span className="navbar-cart-count">( {cartCount} )</span>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}

export default Navbar;
